import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import { useSiteSettings } from '../../providers/siteSettings';

import Copyright     from '../Copyright/Copyright';
import FaceBookIcon  from '../icons/FaceBookIcon';
import InstagramIcon from '../icons/InstagramIcon';
import TelegramIcon  from '../icons/TelegramIcon';
import TikTokIcon    from '../icons/TikTokIcon';
import VKIcon        from '../icons/VKIcon';
import YouTubeIcon   from '../icons/YouTubeIcon';

import {
  FooterContacts,
  FooterNavigation,
  YandexReviewsWidget,
} from './components';

export const Footer = function() {
  const { t } = useTranslation();

  const siteSettings = useSiteSettings();

  const hasSocial = React.useCallback((key) => {
    const setting = siteSettings.data.SOCIALS[key];

    return typeof setting === 'string' && setting.length > 0;
  }, [siteSettings.data.SOCIALS]);

  const country = t('default_country');

  const social = React.useMemo(() => {
    return (
      <div className={'social'}>
        {hasSocial('INSTAGRAM') && (
          <a
            href={siteSettings.data.SOCIALS.INSTAGRAM}
            target={'_blank'}
            rel={'nofollow noopener'}
          ><InstagramIcon /></a>
        )}
        {hasSocial('FACEBOOK') && (
          <a
            href={siteSettings.data.SOCIALS.FACEBOOK}
            target={'_blank'}
            rel={'nofollow noopener'}
          ><FaceBookIcon /></a>
        )}
        {hasSocial('TIKTOK') && (
          <a
            href={siteSettings.data.SOCIALS.TIKTOK}
            target={'_blank'}
            rel={'nofollow noopener'}
          ><TikTokIcon /></a>
        )}
        {hasSocial('TELEGRAM') && (
          <a
            href={siteSettings.data.SOCIALS.TELEGRAM}
            target={'_blank'}
            rel={'nofollow noopener'}
          ><TelegramIcon /></a>
        )}
        {hasSocial('VKONTAKTE') && (
          <a
            href={siteSettings.data.SOCIALS.VKONTAKTE}
            target={'_blank'}
            rel={'nofollow noopener'}
          ><VKIcon /></a>
        )}
        {hasSocial('YOUTUBE') && (
          <a
            href={siteSettings.data.SOCIALS.YOUTUBE}
            target={'_blank'}
            rel={'nofollow noopener'}
          ><YouTubeIcon /></a>
        )}
      </div>
    );
  }, [siteSettings.data.SOCIALS, hasSocial]);

  return (
    <footer>
      <section className={'frontPage_wrapper'}>
        <div className={'footer_wrapper'}>
          <FooterNavigation items={siteSettings.data.FOOTER.NAVIGATION} />
          <FooterContacts
            contacts={siteSettings.data.CONTACTS}
            workingHours={siteSettings.data.WORKING_TIME}
          />
        </div>
        {social}
        <div className={'footer_copyright_section'}>
          <Copyright />
          <YandexReviewsWidget />
        </div>
        <section className={'bottom'}>
          <div className={'bottom_copyright_wrapper'}>
            <span>{`© ${new Date().getFullYear()} ${t('default_copyright')}`}</span>
            {country && (
              <>
                {' '}|{' '}
                <span>{country}</span>
              </>
            )}
          </div>
          {social}
        </section>
      </section>
    </footer>
  );
};